import i18next from "i18next";

type Mapping = { [key: string]: string };

export const transformValue2Back = (value: string, option: string): string => {
    let mapping: Mapping = {}
    if (option === "severity"){
        mapping = {
            [i18next.t("severity_options_low")]: "LOW",
            [i18next.t("severity_options_medium")]: "REGULAR",
            [i18next.t("severity_options_high")]: "HIGH"
        }
    }else if(option === "probability"){
        mapping = {
            [i18next.t("probability_options_low")]: "LOW",
            [i18next.t("probability_options_medium")]: "REGULAR",
            [i18next.t("probability_options_high")]: "HIGH"
        }
    }

    return mapping[value] || value;
};

export const transformValue2Front = (value: string, option: string): string => {
    let mapping: Mapping = {}
    if (option === "severity"){
        mapping = {
            ["LOW"]: i18next.t("severity_options_low"),
            ["REGULAR"]: i18next.t("severity_options_medium"),
            ["HIGH"]: i18next.t("severity_options_high")
        }
    }else if(option === "probability"){
        mapping = {
            ["LOW"]: i18next.t("probability_options_low"),
            ["REGULAR"]: i18next.t("probability_options_medium"),
            ["HIGH"]: i18next.t("probability_options_high")
        }
    }else if(option === "status"){
        mapping = {
            ["NOT_STARTED"]: i18next.t("status_options_not_started"),
            ["GOING"]: i18next.t("status_options_on_time"),
            ["FINISHED"]: i18next.t("status_options_finished")
        }
    }else if(option === "priority"){
        mapping = {
            ["LOW"]: i18next.t("priority_options_low"),
            ["REGULAR"]: i18next.t("priority_options_medium"),
            ["HIGH"]: i18next.t("priority_options_high")
        }
    }

    return mapping[value] || value;
};

export const transformDate2Front = (date: string): string => {
    return date.split('-').reverse().join('/');
}

export const transformDate2Back = (date: string): string => {
    return date.split('/').reverse().join('-');
}